// On-the-fly picker search for clarify forms. Backed by POST /lookup on the
// agentforge server, which runs the same read-only Kula lookup tool the form
// used at build time — with the typed term merged in — and returns options in
// the exact shape the picker already renders. Used for unbounded entities
// (users, projects) where embedding the full list can't scale.

import { callAgentForge } from './http';
import type { ClarifyFieldSearch } from '../types';

export interface LookupOption {
  value: string;
  label: string;
}

export const searchLookupOptions = async (
  search: ClarifyFieldSearch,
  query: string,
  signal?: AbortSignal
): Promise<LookupOption[]> => {
  const res = await callAgentForge<{ options?: LookupOption[] }>({
    method: 'POST',
    url: '/lookup',
    body: {
      tool: search.tool,
      input: search.input ?? {},
      query,
      label_column: search.labelColumn ?? '',
      value_prefix: search.valuePrefix ?? '',
    },
    signal,
  });
  return Array.isArray(res.options)
    ? res.options.filter((o) => o && o.value && o.label)
    : [];
};
